export const Types = {
  SAVE_LIST_USER_CLIENT: 'SAVE_LIST_USER_CLIENT',
  SAVE_LIST_USER_CLIENT_CMS: 'SAVE_LIST_USER_CLIENT_CMS',
  SAVE_USER_CLIENT_BY_ID: 'SAVE_USER_CLIENT_BY_ID',
  SAVE_STATISTIC_USER: 'SAVE_STATISTIC_USER',
  SAVE_USER_REFERRAL_BY_ID: 'SAVE_USER_REFERRAL_BY_ID',
  SAVE_LIST_REFERRAL: 'SAVE_LIST_REFERRAL',
  SAVE_HISTORY_CHANGE_COIN_BY_ID: 'SAVE_HISTORY_CHANGE_COIN_BY_ID',
  SAVE_LIST_CONFIG_MILESTONE: 'SAVE_LIST_CONFIG_MILESTONE',
  SAVE_LIST_MILESTONE_REFERRAL: 'SAVE_LIST_MILESTONE_REFERRAL',
  SAVE_USER_MILESTONE_REFERRAL_BY_ID: 'SAVE_LIST_MILESTONE_REFERRAL_BY_ID',
  SAVE_LIST_USER_KYC: 'SAVE_LIST_USER_KYC',
  SAVE_USER_KYC: 'SAVE_USER_KYC',
  SAVE_LIST_MASTER: 'SAVE_LIST_MASTER',
  SAVE_HISTORY_MASTER: 'SAVE_HISTORY_MASTER',
  SAVE_HISTORY_CHANGE_COIN: 'SAVE_HISTORY_CHANGE_COIN',
  SAVE_LIST_USER_COMMISSION: 'SAVE_LIST_USER_COMMISSION',
  TOP_RUNNER: 'TOP_RUNNER',
  UR_BOX: 'UR_BOX',
  EVENT: 'EVENT',
  SAVE_INVEST_BY_USER: 'SAVE_INVEST_BY_USER',
  SAVE_LIST_REQUEST_UPGRADE_USER: 'SAVE_LIST_REQUEST_UPGRADE_USER',
  SAVE_LIST_LOCK_WITHDRAW_BY_LOGIN : 'SAVE_LIST_LOCK_WITHDRAW_BY_LOGIN',
  SAVE_LIST_PNL : 'SAVE_LIST_PNL',
  SAVE_LIST_HISTORY_PNL : 'SAVE_LIST_HISTORY_PNL'
}
